import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface EventNavbarProps {
  scrolled: boolean;
  eventTitle?: string;
}

export default function EventNavbar({ scrolled, eventTitle }: EventNavbarProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-lg shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className={`flex items-center gap-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-600 hover:text-emerald-600' : 'text-white/80 hover:text-emerald-300'
              }`}
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-left-line text-lg"></i>
              </div>
              Back
            </Link>
            {scrolled && eventTitle && (
              <span className="hidden md:block text-stone-400 text-sm">
                / <span className="text-stone-700 ml-1">{eventTitle}</span>
              </span>
            )}
          </div>

          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 cursor-pointer group">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
                alt="House of FMR"
                className="h-14 w-14 object-contain transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-amber-400/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="hidden sm:block">
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 font-display text-xl tracking-wide">House of FMR</p>
              <p className="text-amber-400/80 text-[10px] tracking-[0.25em] uppercase font-medium">Events & Styling</p>
            </div>
          </Link>

          <Link
            to="/#inquiry"
            className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-yellow-400 text-stone-900 text-sm font-semibold rounded-full hover:from-amber-400 hover:to-yellow-300 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/25"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </nav>
  );
}
